// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"draftEditorToolbarStyles_toolbar__8FfY_"};